import React from "react";
import { HiCheckCircle, HiXMark } from "react-icons/hi2";
import Button from "../Button/Button";
import "./SuccessModal.scss";

const SuccessModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="success-modal-overlay" onClick={onClose}>
            <div className="success-modal" onClick={(e) => e.stopPropagation()}>
                <button className="success-modal__close" onClick={onClose}>
                    <HiXMark />
                </button>

                <div className="success-modal__content">
                    <div className="success-modal__icon">
                        <HiCheckCircle />
                    </div>

                    <h2 className="success-modal__title">
                        ¡Proyecto Enviado con Éxito!
                    </h2>

                    <p className="success-modal__message">
                        Tu solicitud ha sido enviada correctamente. En breve nos
                        pondremos en contacto contigo para facilitarte la
                        información solicitada.
                    </p>

                    <Button
                        variant="filled"
                        animationType="pop"
                        onClick={onClose}
                    >
                        Entendido
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SuccessModal;
